import Vue from 'vue'
import Router from 'vue-router'


import store from '../store/index'
import ViewUI from 'view-design'

import error from './modules/error'
import Layout from '@/views/Layout'
import entry from './modules/entry'
import compInstructions from './modules/compInstructions'
import authorizedMenus from './modules/authorized'

Vue.use(Router)

export const staticRouter = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录...',
      code: 'login'
    },
    // component: resolve => require(['@/views/Layout'],resolve)
    component: resolve => require(['@/views/login'], resolve)
  },
  ...entry,
  ...compInstructions,
  ...authorizedMenus,
  {
    path: '/',
    name: 'Main',
    component: resolve => require(['@/views/Main'], resolve),
    // setting & cockpit
    children: []
  },
  {
    path: '/dataUser',
    name: 'dataUser',
    meta: {
      code: 'dataUser',
      title: '无页面访问权限',
      authorized: true,
    },
    component: resolve => require(['@/views/errorpage/DataUser'], resolve)
  },

]

const VueRouterPush = Router.prototype.push

Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const createRouter = (routers) => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: '/',
  routes: routers
})

const router = createRouter(staticRouter)

export function resetRouter () {
  const newRouter = createRouter(staticRouter)
  router.matcher = newRouter.matcher // the relevant part
}

router.beforeEach(async (to, from, next) => {
  ViewUI.LoadingBar.start()
  if (from.name == to.name) {
    // donothing
    ViewUI.LoadingBar.finish()
  } else {
    console.log("from", from)
    console.log("to", to)
    if (to.path == from.path && to.path != "/") {
      // next()
      // 页面没有变化 不做处理
    } else if (to.matched == undefined || to.matched.length == 0) {
      console.log('notFound ....')
      next({ name: "notFound" })
    } else if (to.meta.isExtraLink) {
      //外連接
      window.open(to.meta.orgPath, to.meta.pageOpenType || '_blank')
    } else {
      if (to.meta.authorized || to.authorized) {
        // 无需授权页面
        next()
      } else {
        let token = to.query.token
        console.log('token', token)
        if (token) {
          await store.dispatch('createToken', token)
          next()
        } else {
          let data = store.getters.checkData
          console.log('checkData data', data)
          if (to.name == 'login' || data == undefined || data == null || Object.keys(data).length == 0 || data.expried < new Date().getTime() || data.SHAREDJSESSIONID == null || data.SHAREDJSESSIONID == undefined) {
            store.dispatch('resetAll')
            if (to.path != '/login') {
              //不然就跳转到登录;
              next({ path: '/login', replace: true })
            } else {
              next()
            }
          } else {
            // 代表当前token有效
            let userInfo = store.getters['userInfo/user'] || {}
            console.log('userInfo', userInfo)
            if (['login', 'sessionLogin'].indexOf(to.name) < 0) {
              let permissions = userInfo.menuPermissions || []
              if (permissions.indexOf(to.meta.code) >= 0) {
                next()
              } else {
                next({ path: '/unAuthorized', replace: true })
              }
            } else {
              let systemInfo = store.getters['systemInfo/systemInfo'] || {}
              //如果有门户 进入门户页面 否则获取用户默认路径
              console.log('systemInfo', systemInfo)
              if (systemInfo.hasPortal && systemInfo.portalPath) {
                console.log('portalPath', systemInfo.portalPath)
                next({ path: systemInfo.portalPath })
              } else {
                //没有门户 代表就默认的系统设置入口 默认
                let defaultUrl = userInfo.defaultUrl
                console.log('defaultUrl', defaultUrl)
                if (defaultUrl) {
                  next({ path: defaultUrl, replace: true })
                } else {
                  // 获取默认用户有权限的的第一个菜单
                  let systemSettingMenus = store.getters['menuInfo/entryMenus'] || {}
                  console.log('systemSettingMenus', systemSettingMenus)
                  let menus = systemSettingMenus.system_menu || systemSettingMenus.config_menu || []
                  if (menus.length > 0) {
                    console.log('to menu', menus[0])
                    next({ name: menus[0].pathName, replace: true })
                  }
                  else next({ name: 'Main', replace: true })
                }
              }
            }

          }
        }
      }
    }
  }
})

router.afterEach((to, from) => {
  ViewUI.LoadingBar.finish()
  window.document.title = to.meta.title
})

export const addPermissionRoute = (params, entryMenus) => {
  console.log('addPermissionRoute', params)
  router.options.hasLoadRouters = true
  if (params) {
    console.log('addPermissionRoute resetRouter')
    resetRouter()
  }
  return new Promise((resolve, reject) => {
    if (entryMenus && Object.keys(entryMenus).length > 0) {
      // 1. 驾驶舱初始化
      let cockpitMenus = entryMenus['cockpit_menu'] || []
      if (cockpitMenus.length > 0) {
        //这个地方加个父层级 方便拓展
        let defaultPath = store.getters['menuInfo/cockpitCode'] || 'default'
        let children = structuredMenu(cockpitMenus, 0, false, 'cockpit_menu', 'FULL', '', false)
        let part = {
          path: '/cockpitManage',
          name: 'cockpitManage',
          meta: {
            title: '驾驶舱',
            structure: 'FULL',
            children: children,
          },
          component: resolve => require([`@/views/cockpitManage/${defaultPath}/CockpitManage`], resolve),
          children: children,
        }
        if (children && children.length > 0) {
          part.redirect = { name: children[0].name }
        }
        router.addRoute('Main', part)
      }

      let configMenus = entryMenus['config_menu'] || []
      let systemMenus = entryMenus['system_menu'] || []
      if (configMenus.length > 0 || systemMenus.length > 0) {
        if (systemMenus.length > 0) {
          let children = structuredMenu(systemMenus, 0, false, 'system_menu', '', '', false)
          children.forEach(item => {
            router.addRoute('Main', item)
          })
        }

        if (configMenus.length > 0) {
          let children = structuredMenu(configMenus, 0, true, 'config_menu', '', '', true)
          children.forEach(item => {
            router.addRoute('Main', item)
          })
        }
      }
    }
    addErrorRoute()
    resolve(true)
  })
}

export const addErrorRoute = () => {
  error.forEach(item => {
    router.addRoute('Main', item)
  })
}


export function structuredMenu (menuAll, level, isSettingMenu, pluginMenuType, structure, openName, isBack) {
  let menuList = []
  level++
  if (menuAll != undefined && menuAll.length > 0) {
    menuAll.forEach(m => {
      try {
        if (m.isExtraLink == false) {
          m.componentPath = m.componentPath.indexOf("/") == 0 ? m.componentPath : '/' + m.componentPath
        }
        let baseDir = 'systemManage'
        if (level == 1) {
          openName = m.pathName
          isSettingMenu = m.isSettingMenu
        }
        if (!pluginMenuType) pluginMenuType = m.pluginMenuType
        if (pluginMenuType == 'cockpit_menu') {
          baseDir = 'cockpitManage'
        } else if (isSettingMenu) {
          baseDir = 'supportManage'
        }
        let menu = {
          id: m.id,
          path: m.componentPath,
          name: m.pathName,
          meta: {
            isBack: isBack,
            openName: openName,
            activeName: m.pathName,
            orgPath: m.componentPath,
            isExtraLink: m.isExtraLink,
            pageOpenType: m.pageOpenType,
            isSettingMenu: isSettingMenu,
            title: m.menuName,
            code: m.menuCode,
            structure: m.structure || structure,
            pluginMenuType: pluginMenuType,
            icon: m.menuIcon,
            checkedPermissions: m.checkedPermissions,
            showBreadcrumb: true
          }
        }
        if (m.children && m.children.length > 0) {
          menu.path = m.pathName
          menu.children = structuredMenu(m.children, level, isSettingMenu, pluginMenuType, menu.meta.structure, openName, isBack)
          menu.redirect = { name: menu.children[0].name }
          menu.component = Layout
        } else if (m.hasDetail && m.subPages && m.subPages.length > 0) {
          menu.path = m.componentPath + 'Mock'
          // menu.name =  m.entryCode + m.pathName + 'Mock'
          menu.name = (m.componentPath + 'Mock').split('/').join('')
          menu.component = Layout

          let children = []
          children.push({
            id: m.id,
            path: m.componentPath,
            name: m.pathName,
            // name: (m.entryCode + m.componentPath).split('/').join(''),
            meta: {
              isBack: isBack,
              openName: openName,
              activeName: m.pathName,
              orgPath: m.componentPath,
              isExtraLink: m.isExtraLink,
              pageOpenType: m.pageOpenType,
              isSettingMenu: m.isSettingMenu,
              title: m.menuName,
              structure: m.structure || structure,
              code: m.menuCode,
              // structure: m.structure,
              pluginMenuType: m.pluginMenuType,
              icon: m.menuIcon,
              checkedPermissions: m.checkedPermissions,
              showBreadcrumb: true
            },
            component: () => import(`@/views/${baseDir}${m.componentPath}.vue`)
          })

          m.subPages.forEach(sub => {
            if (sub.name && sub.path) {
              let pre = sub.path.indexOf('/') == 0 ? '' : '/'
              children.push({
                id: m.id,
                path: pre + sub.path,
                name: (pre + sub.path).split('/').join(''),
                meta: {
                  isBack: isBack,
                  openName: openName,
                  activeName: m.pathName,
                  orgPath: sub.path,
                  isExtraLink: m.isExtraLink,
                  pageOpenType: m.pageOpenType,
                  isSettingMenu: m.isSettingMenu,
                  title: sub.name,
                  code: m.menuCode,
                  structure: m.structure || structure,
                  pluginMenuType: m.pluginMenuType,
                  icon: m.menuIcon,
                  checkedPermissions: m.checkedPermissions,
                  showBreadcrumb: true
                },
                component: () => import(`@/views/${baseDir}${pre}${sub.path}.vue`)

              })
            }
          })
          menu.children = children
          menu.redirect = { name: children[0].name }
        } else {
          if (pluginMenuType == 'cockpit_menu') {
            menu.component = Layout
          } else {
            menu.component = () => import(`@/views/${baseDir}${m.componentPath}.vue`)
          }
        }
        menuList.push(menu)
      } catch (error) {
        console.log(m.componentPath, error)
      }
    })
  }
  return menuList
}

export default router